/**
 * Zzzing Admin API
 * Zzzing Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: ci@zzzing.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PropertyBasicShortRef } from './propertyBasicShortRef';
import { BasicLandOwnerShortRef } from './basicLandOwnerShortRef';
import { BasicContractShortRef } from './basicContractShortRef';
import { ReservationShortRef } from './reservationShortRef';


export interface ContractReservationFinancial { 
    reservation_id?: string;
    reservation_short_ref?: ReservationShortRef;
    entry_date?: string;
    owner_booking?: boolean;
    contract_short_ref?: BasicContractShortRef;
    owner_short_ref?: BasicLandOwnerShortRef;
    property_short_ref?: PropertyBasicShortRef;
    gross_rent?: number;
    tourist_tax?: number;
    ota_fee_rent?: number;
    ota_fee_tourist_tax?: number;
    payment_charge?: number;
    vh_service_charge?: number;
    owner_share?: number;
    periodic_entry_id?: string;
    processed_timestamp?: string;
}

